module.exports = __webpack_public_path__ + "img/linkedin.2ca684c0.png";